import { STATUS_SEVERITY_MAP } from "../../../data/constants";

export const LOCATION_STATUS_PRIORITY_MAP = {
  [STATUS_SEVERITY_MAP.critical]: 1,
  [STATUS_SEVERITY_MAP.warning]: 2,
  [STATUS_SEVERITY_MAP.healthy]: 3
};
